import { useMemo } from 'react';
import { useOrgValue } from 'hooks/business/system/useOrg';
import { toNumber } from 'lodash-es';

// 是否有生效套餐
const useIsValidPackage = () => {
  const orgValue = useOrgValue();

  return useMemo(
    () =>
      Math.max(
        toNumber(orgValue?.activeExpireTimestamp ?? '0'),
        toNumber(orgValue?.renewExpireTimestamp ?? '0'),
      ) > Date.now(),
    [orgValue],
  );
};

export default useIsValidPackage;
